import { FETCHING_LINEINFORMATION, FETCH_LINEINFORMATION_SUCCESS } from "./LineDataInformationConstants";

const initialState = {
  fetchingLineDataInformation: false,
  linesCount: {}
};

const LineDataInformationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCHING_LINEINFORMATION:
      return { ...state, fetchingLineDataInformation: true };
    case FETCH_LINEINFORMATION_SUCCESS:
      return { ...state, fetchingLineDataInformation: false, linesCount: action.lineDataInformation };
    default:
      return state;
  }
};

export default LineDataInformationReducer;



// WEBPACK FOOTER //
// ./src/redux/lineDataInformation/LineDataInformationReducer.js